import React from "react";

export const PlanFeatureUpgradeButton = ({ onClick, stopPropagation = false, text = 'Faça upgrade' }) => {
    const handleClick = event => {
        if (stopPropagation) {
            event.stopPropagation();
        }

        onClick();
    };

    const handleKeyDown = event => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();

            if (stopPropagation) {
                event.stopPropagation();
            }

            onClick();
        }
    };

    return (
        <span
            onClick={handleClick}
            className="upgrade-cta"
            role="button"
            tabIndex={0}
            onKeyDown={handleKeyDown}
        >
            <span className="upgrade-cta__icon">🚀</span>
            <span className="upgrade-cta__text">{text}</span>
        </span>
    );
};

export default PlanFeatureUpgradeButton;
